import type { Achievement } from "../achievement.types";

export const tenStepsAheadAchievement: Achievement = {
  id: "tenStepsAhead",
  name: "Ten Steps Ahead",
  description: "Finished ten games ahead of Ariadne.",
  icon: "run-fast",
  check: (gameReport, gameStatus) =>
    gameStatus === "won" && (gameReport?.ariadneGamesAhead ?? 0) >= 10,
};
